var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("speech-and-language", {
    attrs: {
      "add-treatment": _vm.addTreatment,
      "complete-appointment": _vm.saveAppointmentTabI,
      "delete-location": _vm.deleteLocation,
      "delete-relationship": _vm.deleteRelationship,
      "delete-treatment": _vm.deleteTreatment,
      "edit-location": _vm.editLocation,
      "edit-relationship": _vm.editRelationship,
      "edit-treatment": _vm.editTreatment,
      "full-profile": _vm.fullProfileData,
      "get-all-treatments": _vm.getAllTreatments,
      "get-appointment-for-tabi": _vm.getAppointmentForTabi,
      "get-appointment-info": _vm.getAppointmentInfo,
      "get-appointment-locations": _vm.getAppointmentLocations,
      "get-appointment-municipalities": _vm.getAppointmentMunicipalities,
      "get-appointment-recommendation": _vm.getAppointmentRecommendation,
      "get-appointment-specialist-signature":
        _vm.getAppointmentSpecialistSignature,
      "get-discipline-types": _vm.getServices,
      "get-frequency-type": _vm.getFrequencyType,
      "get-location-types": _vm.getLocationTypes,
      "get-locations": _vm.getLocations,
      "get-municipalities": _vm.getMunicipalities,
      "get-recommendation-reason": _vm.getRecommendationReason,
      "get-recommendation-reason-register": _vm.getRecommendationReasonRegister,
      "get-referral-reason": _vm.getReferralReason,
      "get-relationship-types": _vm.getRelationshipTypes,
      "get-relationships": _vm.getRelationships,
      "get-service-modalities": _vm.getServiceModalities,
      "get-specialist-by-location": _vm.getSpecialistByLocation,
      "get-specialist-practitioners": _vm.getSpecialistPractitioners,
      "get-tab-sections": _vm.getTabSections,
      "get-therapy-durations": _vm.getTherapyDurations,
      "get-therapy-period": _vm.getTherapyPeriod,
      "save-appointment-specialist-signature":
        _vm.saveAppointmentSpecialistSignature,
      "save-location": _vm.saveLocation,
      "save-no-recommendation": _vm.saveNoRecommendation,
      "save-recommendation": _vm.saveRecommendation,
      "save-relationship": _vm.saveRelationship,
      "save-tab-sections": _vm.saveTabSections,
      "submit-appointment-tabs": _vm.submitAppointmentTabs
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }